import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_4 = { class: "field mt-3" }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = { class: "field mt-3" }
const _hoisted_7 = {
  key: 0,
  class: "p-error"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}

import { onMounted, ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

import { useSalesRepStore } from '@/store/Admin/Tenant/SalesRep';
import { useTenantStore } from '@/store';

import { CreateSalesRepInterface, TenantUsersInterface } from '@/types';
import { EMIT } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddSalesRep',
  emits: [EMIT.CANCEL, EMIT.SAVE, EMIT.CLOSE],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const visible = ref(true);
const mode = ref<'manual' | 'select'>('manual');
const salesRepStore = useSalesRepStore();
const tenantStore = useTenantStore();
const firstName = ref('');
const lastName = ref('');
const selectedUser = ref<TenantUsersInterface | null>(null);
const availableUsers = computed(() => tenantStore.userDropdown);
const errors = ref<{ firstName?: string; lastName?: string; selectedUser?: string }>({});
const route = useRoute();
const id = ref<number>();

function splitDisplayName(displayName: string): { first_name: string; last_name: string } {
  const parts = displayName.trim().split(' ');
  const first_name = parts[0];
  const last_name = parts.slice(1).join(' ') || '';
  return { first_name, last_name };
}

function validateForm() {
  errors.value = {};

  if (mode.value === 'manual') {
    if (!firstName.value) errors.value.firstName = 'First name is required.';
    if (!lastName.value) errors.value.lastName = 'Last name is required.';
    return !errors.value.firstName && !errors.value.lastName;
  } else {
    if (!selectedUser.value) errors.value.selectedUser = 'User selection is required.';
    return !!selectedUser.value;
  }
}

async function submit() {
  if (!validateForm()) return;

  const createSalesRep = () => {
    if (mode.value === 'manual') {
      const payload: CreateSalesRepInterface = {
        first_name: firstName.value,
        last_name: lastName.value,
        display_name: `${firstName.value} ${lastName.value}`,
      };
      return salesRepStore.createSalesRep(payload);
    } else if (selectedUser.value) {
      const { first_name, last_name } = splitDisplayName(selectedUser.value.display_name);
      const payload: CreateSalesRepInterface = {
        person_id: selectedUser.value.id,
        display_name: selectedUser.value.display_name,
        first_name,
        last_name,
      };
      return salesRepStore.createSalesRep(payload);
    }
  };

  const result = createSalesRep();
  if (result) {
    result
      .then(() => {
        salesRepStore.doToast('Sales Rep created');
        emit(EMIT.SAVE);
      })
      .catch((error: { status: number; data: { message: string } }) => {
        if (error.status == 422) {
          salesRepStore.doToast(`Failed to save Sales Rep: ${error.data.message}`, '', true);
        } else {
          salesRepStore.doToast(`An unknown error occurred`, '', true);
        }
        emit(EMIT.CLOSE);
      });
  }
}

watch(visible, (val) => {
  if (!val) emit(EMIT.CANCEL);
});

onMounted(async () => {
  if (route.params.id) {
    id.value = parseInt(route.params.id as string);
    await tenantStore.getTenantUsers(id.value);
  }
  id.value = parseInt(route.params.id as string);
});

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
    header: "Add Sales Rep",
    modal: "",
    style: {"width":"30rem"}
  }, {
    header: _withCtx(() => [...(_cache[7] || (_cache[7] = [
      _createElementVNode("h2", null, "Add Sales Rep", -1)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        text: "Cancel",
        type: "secondary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit(_unref(EMIT).CANCEL)))
      }),
      _createVNode(_component_AppButton, {
        text: "Save",
        type: "primary",
        onClick: submit
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "font-semibold mb-2 block" }, "Select Method", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppButton, {
            text: "New User",
            type: "primary",
            outlined: mode.value !== 'manual',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (mode.value = 'manual'))
          }, null, 8, ["outlined"]),
          _createVNode(_component_AppButton, {
            text: "Existing User",
            type: "primary",
            outlined: mode.value !== 'select',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (mode.value = 'select'))
          }, null, 8, ["outlined"])
        ])
      ]),
      (mode.value === 'manual')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "required" }, "First Name", -1)),
              _createVNode(_unref(InputText), {
                modelValue: firstName.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstName).value = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"]),
              (errors.value.firstName)
                ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(errors.value.firstName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "required" }, "Last Name", -1)),
              _createVNode(_unref(InputText), {
                modelValue: lastName.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lastName).value = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"]),
              (errors.value.lastName)
                ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(errors.value.lastName), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "required" }, "Select User", -1)),
            _createVNode(_unref(Dropdown), {
              modelValue: selectedUser.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedUser).value = $event)),
              options: availableUsers.value,
              "option-label": "display_name",
              placeholder: "Select a user",
              class: "w-full"
            }, null, 8, ["modelValue", "options"]),
            (errors.value.selectedUser)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(errors.value.selectedUser), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})